module.exports = __webpack_public_path__ + "static/map-b05527c0e6c96de72a8b72251433d657.svg";